import { Amplify } from "aws-amplify";

export function configureAmplifyAuth(
  userPoolId: string,
  userPoolClientId: string,
): void {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        loginWith: {
          email: true,
        },
      },
    },
  });
}
